<template>
    <div id="login">

        <div id="login_module" class="col-10 col-sm-4 col-md-4 col-lg-3 p-0">
            <img v-if="!this.task.error && !this.task.sent" src="https://www.leffix.playworld.nl/themes/assets/playworld/logo_200.png" alt="">
            <h2 v-if="!this.task.error && !this.task.sent" >Account validatie</h2>
            <div  id="form"> 
                <div v-if="!this.task.error && !this.task.sent" class="form-group">
                    <div class="roller"></div>
                    <h6 style="color:white" class="mb-4 text-center">Token wordt gevalideerd......</h6>    
                </div> 
                <div v-if="this.task.error" class="form-group m-0">
                     <div class="alert alert-danger m-0">
                         {{this.task.msg}}
                     </div>
                </div> 
                 <div v-if="this.task.sent" class="form-group m-0">
                     <div class="alert alert-success m-0">
                         {{this.task.msg}}
                     </div>
                </div> 
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name:'ValidationEmail',
    data(){
        return {
            login:{
                email:'',
                password:''
            },
            task:{
                sent:false,
                error:false,
                msg:'', 
                task_loader:false
            }
        }
    },
    methods:{
       
    },
    created(){
        let token=this.$route.params.token;
       this.$store.dispatch('get',this.$store.state.endpoint+'validate-account/'+token)
       .then((data)=>{
           console.log(data);
           this.task.sent=true;
           this.task.msg="Emailadres bevestigd. Uw inloggegevens zijn gegenereerd en per email toegezonden.";
       })
       .catch((error)=>{
           console.log(error.request)
           if(error.request.status == 403){
               this.task.error=true;
               this.task.msg="Validatie token ongeldig.";
           }
       });
    }
}
</script>

<style scoped>
    .roller{
        display: block;
        border:2px solid lightgray;
        padding: 10px;
        width: fit-content;
        border-radius: 50%;
        border-top:2px solid red;
        animation:roll .4s linear infinite;
        margin: auto;
    }
    @keyframes roll {
        0%{
        transform: rotate(0deg)
        }
        100%{
        transform: rotate(360deg)
        }
    }
    #task_loader{
        width: 20px;
        height: 20px;
        border: 2px solid gray;
        border-top: 2px solid white;
        border-radius: 50%;
        position: absolute;
        left: 15%;
        margin-top: 0.7%;
        animation: spin .6s linear infinite;
    }
     @keyframes spin{
        0%{
            transform: rotate(0deg);
        }
        100%{
            transform: rotate(360deg);
        }
    }
    body{
        background-color:#222 !important;
    }
    #login_module .foot{
        padding: 10px 16px;
    }
    #login_module .foot a{
        font-size: 13px;
        font-weight: bold;
        color: #545454;
    }
    #login_module{
        position: absolute;
        top:0;
        bottom:0;
        left:0;
        right:0;
        margin:auto;
        background: #222;
        display: table;
        border-radius: 5px;
        box-shadow: 0px 0px 3px gray;
    }
    #login_module img{
        width: 265px;
        display: block;
        margin: 0 auto;
        margin-top: -13px;
        background-color: #222;
        border-radius: 7px;
        box-shadow: 0px 0px 2px grey;
        padding: 5px 7px;
    }
    #login_module h2{
        text-align: center;
        margin: 20px 0px;
        color: #faba05;
        font-weight: 700;
    }
    #login_module form{
        text-align: center;
        
    }
    #login_module form input:focus{
        border:1px solid #faba05;
        box-shadow: none;
    }
</style>
